import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = ["placeholder", "disabled"]
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "text-left" }
const _hoisted_22 = { class: "flex flex-row flex-wrap flex-shrink gap-2" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "text-left" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "mr-24" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "flex gap-6 flex-wrap" }
const _hoisted_29 = { class: "text-left" }
const _hoisted_30 = { class: "text-left" }
const _hoisted_31 = { class: "mt-5 sm:mt-6 text-center" }

import { translate } from "@/utils/tools";
import { computed, inject, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import FileUploader from "../tools/FileUploader.vue";
import DropdownComponent from "../tools/DropdownComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerCreateDialog',
  props: {
  show: Boolean,
},
  emits: ["submit", "update:show", "update:form", "created"],
  setup(__props, { emit }) {

const props = __props

const store = useStore();
const axios = inject("$axios") as AxiosInstance;
const file = ref();
const images = ref([]);
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const form = ref({
  operatorId: store.state.selectedOperator.operatorId,
  slug: "",
  keyName: "",
  description: "",
  linkTo: "",
  schedulerDateStart: undefined,
  schedulerDateEnd: undefined,
  schedulerTimeStart: undefined,
  schedulerTimeEnd: undefined,
  hasScheduler: false,
  images: [
    {
      url: "",
      link: "",
    },
  ],
});
const preview = ref();
const isOnetime = ref(false);
const avaliableDays = ref<string[]>([]);
const isLoading = ref(false);
const selectedSlug = ref({
  label: "--Select Slug--",
  value: "",
});
const days = ref([
  { name: translate("messages.banner.sunday"), val: "SUN" },
  { name: translate("messages.banner.monday"), val: "MON" },
  { name: translate("messages.banner.tuesday"), val: "TUE" },
  { name: translate("messages.banner.wednesday"), val: "WED" },
  { name: translate("messages.banner.thuesday"), val: "THU" },
  { name: translate("messages.banner.friday"), val: "FRI" },
  { name: translate("messages.banner.saturday"), val: "SAT" },
]);

const slugs = ref([
  { label: translate("messages.banner.home"), value: "home" },
  { label: translate("messages.banner.dashboard"), value: "dashboard" },
  { label: translate("messages.banner.commission"), value: "commission" },
  { label: translate("messages.banner.affiliate"), value: "affiliate" },
  { label: translate("messages.banner.reward"), value: "reward" },
  { label: translate("messages.banner.deposit"), value: "deposit" },
  { label: translate("messages.banner.withdraw"), value: "withdraw" },
  { label: translate("messages.banner.transaction"), value: "transaction" },
  { label: translate("messages.banner.history"), value: "history" },
])

const onSelectSchudule = (val: string) => {
  if (avaliableDays.value.includes(val)) {
    avaliableDays.value = avaliableDays.value.filter((a) => a !== val);
  } else {
    avaliableDays.value.push(val);
  }
};

const onCreate = async () => {
  if (isLoading.value) return;
  isLoading.value = true;
  try {
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/banner/create`,
      {
        ...form.value,
        slug:
          form.value.slug === ""
            ? form.value.keyName.split(" ").join("-")
            : form.value.slug,
        schedulerDay: avaliableDays.value,
        isOneTime: isOnetime.value,
        hasScheduler: form.value.hasScheduler,
      }
    );

  } catch (e) {
    console.log(e)
  } finally {
    isLoading.value = false;
  }

  emit("created");
  showSync.value = false;
};



const onClose = () => {
  form.value.images = [];
  images.value = [];
  preview.value = "";
  showSync.value = false;
};

const onSlugSelected = (e: any) => {
  // console.log("onSlugSelected : ",e.value)
  form.value.slug = e.value;
  selectedSlug.value = e;
};


watch(images, (val: any) => (form.value.images = val));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[12] || (_cache[12] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.banner.createBanner")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.banner.slug")), 1),
                            _createVNode(DropdownComponent, {
                              class: "w-full",
                              options: slugs.value,
                              modelValue: selectedSlug.value,
                              onOnOptionSelected: onSlugSelected
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("messages.banner.keyname")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "rounded w-full",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.keyName) = $event)),
                              placeholder: _ctx.$t('messages.banner.keyname')
                            }, null, 8, _hoisted_8), [
                              [_vModelText, form.value.keyName]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("messages.banner.description")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "rounded w-full",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.description) = $event)),
                              placeholder: _ctx.$t('messages.banner.description')
                            }, null, 8, _hoisted_10), [
                              [_vModelText, form.value.description]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("messages.banner.linkTo")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.linkTo) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.banner.linkTo')
                            }, null, 8, _hoisted_12), [
                              [_vModelText, form.value.linkTo]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("messages.banner.schedulerStartDate")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (((form.value as any).schedulerDateStart) = $event)),
                              placeholder: _ctx.$t('messages.banner.schedulerStartDate')
                            }, null, 8, _hoisted_14), [
                              [_vModelText, (form.value as any).schedulerDateStart]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("messages.banner.schedulerStartTime")), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (((form.value as any).schedulerTimeStart) = $event)),
                              type: "time",
                              class: "w-full rounded",
                              placeholder: _ctx.$t('messages.banner.schedulerStartTime'),
                              disabled: (form.value as any).schedulerDateStart ? false : true
                            }, null, 8, _hoisted_16), [
                              [_vModelText, (form.value as any).schedulerTimeStart]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("messages.banner.schedulerEndDate")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (((form.value as any).schedulerDateEnd) = $event)),
                              placeholder: _ctx.$t('messages.banner.schedulerEndDate')
                            }, null, 8, _hoisted_18), [
                              [_vModelText, (form.value as any).schedulerDateEnd]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("messages.banner.schedulerTimeEnd")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              disabled: (form.value as any).schedulerDateEnd ? false : true,
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (((form.value as any).schedulerTimeEnd) = $event))
                            }, null, 8, _hoisted_20), [
                              [_vModelText, (form.value as any).schedulerTimeEnd]
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("messages.banner.schedulerRepeat")), 1),
                          _createElementVNode("div", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day, index) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: index,
                                class: _normalizeClass(["uppercase rounded px-2", avaliableDays.value.includes(day.val)
                        ? 'bg-blue-500 text-white'
                        : 'bg-indigo-100'
                        ]),
                                onClick: ($event: any) => (onSelectSchudule(day.val))
                              }, _toDisplayString(day.name), 11, _hoisted_23))
                            }), 128))
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("messages.banner.image")), 1),
                            _createVNode(FileUploader, {
                              "upload-type": "banner",
                              endpoint: "/upload/api/internal/image",
                              images: images.value,
                              "onUpdate:images": _cache[7] || (_cache[7] = ($event: any) => ((images).value = $event))
                            }, null, 8, ["images"])
                          ]),
                          (preview.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("messages.banner.previewImage")), 1),
                                _createElementVNode("img", {
                                  src: preview.value,
                                  class: "mx-auto w-52 h-52 object-contain"
                                }, null, 8, _hoisted_27)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createTextVNode(_toDisplayString(_ctx.$t("messages.banner.onetimeDisplay")) + " ", 1),
                              _createVNode(_unref(Switch), {
                                modelValue: isOnetime.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isOnetime).value = $event)),
                                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", isOnetime.value ? 'bg-blue-400' : 'bg-red-500'])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([isOnetime.value ? 'translate-x-6' : 'translate-x-1'
                            , "inline-block h-4 w-4 transform rounded-full bg-white"])
                                  }, null, 2)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "class"])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createTextVNode(_toDisplayString(_ctx.$t("messages.banner.useScheduler")) + " ", 1),
                              _createVNode(_unref(Switch), {
                                modelValue: form.value.hasScheduler,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.hasScheduler) = $event)),
                                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", form.value.hasScheduler ? 'bg-blue-400' : 'bg-red-500'
                            ])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([form.value.hasScheduler
                            ? 'translate-x-6'
                            : 'translate-x-1'
                            , "inline-block h-4 w-4 transform rounded-full bg-white"])
                                  }, null, 2)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "class"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.banner.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (onCreate())),
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.banner.submit")), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})